import { FC, ReactNode } from 'react';
import { Link } from '@material-bank/mb-uikit/components/Link';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  AuthFormControlInput,
  AuthFormControlInputProps,
  AuthFormInput,
} from '../../../../../../modules/auth';
import { uiTranslations } from '../../../../../../shared/config/i18n';
import { PageUrl } from '../../../../../../shared/config/pages';
import { getPasswordSignInFormRules } from '../../../../../../shared/lib/forms';
import { translations } from '../../../../i18n';
import { SignInFormErrorType, SignInFormValues } from '../signInForm';

export interface PasswordFieldProps
  extends Partial<AuthFormControlInputProps<SignInFormValues, 'password'>> {}

const errorMessages: Partial<Record<string, ReactNode>> = {
  [SignInFormErrorType.INCORRECT_EMAIL_OR_PASSWORD]: (
    <>
      <FormattedMessage {...translations.signInView.incorrectEmailOrPassword} />{' '}
      <Link href={PageUrl.RESET_PASSWORD} withUnderline inherit>
        <FormattedMessage {...translations.signInView.resetPassword} />
      </Link>
    </>
  ),
};

export const PasswordField: FC<PasswordFieldProps> = (props) => {
  const { ...inputProps } = props;

  const intl = useIntl();

  return (
    <AuthFormControlInput
      name="password"
      placeholder={intl.formatMessage(uiTranslations.password)}
      type="password"
      autoComplete="current-password"
      rules={{
        ...getPasswordSignInFormRules(intl),
        required: true,
      }}
      renderInput={(inputProps, { fieldState: { error } }) => (
        <AuthFormInput
          {...inputProps}
          helperText={
            error ? error.message ?? errorMessages[error.type] : undefined
          }
        />
      )}
      {...inputProps}
    />
  );
};
